'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _TabIndex = require('../utils/TabIndex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIUnstyledButton',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    onClick: _react.PropTypes.func,
    onMouseDown: _react.PropTypes.func,
    tabIndex: _react.PropTypes.number,
    type: _react.PropTypes.oneOf(['button', 'reset', 'submit']).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      type: 'button'
    };
  },
  handleMouseDown: function handleMouseDown(evt) {
    var onMouseDown = this.props.onMouseDown;


    if (this.props.disabled) {
      evt.stopPropagation();
    }

    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;


    if (this.props.disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        disabled = _props.disabled,
        __onClick = _props.onClick,
        __onMouseDown = _props.onMouseDown,
        tabIndex = _props.tabIndex,
        rest = _objectWithoutProperties(_props, ['className', 'disabled', 'onClick', 'onMouseDown', 'tabIndex']);

    return _react2.default.createElement('button', _extends({}, rest, {
      'aria-disabled': disabled,
      className: (0, _reactUtils.classNames)('private-button--unstyled', className),
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex)
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/button/UIUnstyledButton.js
// module id = 457
// module chunks = 0